import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { Collapse, collapseClasses, Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { documentsAtom, orderAtom } from '../state/state';
import BuyerInfoDialog, { BuyerView } from '../../company/buyer/dialog/BuyerInfoDialog';
import useOpenable from '../../hooks/useOpenable';
import Comments from './comments/Comments';
import Documents from './documents/Documents';

export interface OrderAdditionalInformationProps {
  compact?: boolean;
}

export default function OrderAdditionalInformation({ compact }: OrderAdditionalInformationProps): React.JSX.Element {
  const { t } = useTranslation(['comments', 'common', 'order']);
  const order = useAtomValue(orderAtom);
  const documents = useAtomValue(documentsAtom);
  const [view, setView] = useState<BuyerView>();
  const { open, close, isOpen } = useOpenable();
  const [documentIsExpanded, setDocumentIsExpanded] = useState<boolean>(false);

  const openBuyerDialog = (selectedView: BuyerView): void => {
    setView(selectedView);
    open();
  };

  return (
    <List
      sx={{
        py: 0,
      }}
    >
      <ListItemButton onClick={() => setDocumentIsExpanded(!documentIsExpanded)}>
        <ListItemIcon>
          <FilePresentOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={t('order:N_documents', { count: Object.keys(documents).length })} />
        <ListItemIcon>
          {documentIsExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </ListItemIcon>
      </ListItemButton>
      <Collapse
        in={documentIsExpanded}
        timeout="auto"
        sx={{
          [`& .${collapseClasses.wrapper}`]: {
            py: 2,
          },
        }}
      >
        <Documents />
      </Collapse>
      <Divider />
      <ListItemButton onClick={() => openBuyerDialog('DELIVERY')}>
        <ListItemIcon>
          <LocalShippingOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={t('common:delivery')}
        />
        <ListItemIcon>
          <ArrowRightOutlinedIcon />
        </ListItemIcon>
      </ListItemButton>
      <Divider />
      <ListItemButton onClick={() => openBuyerDialog('INVOICING')}>
        <ListItemIcon>
          <ReceiptLongOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={t('common:billing')}
        />
        <ListItemIcon>
          <ArrowRightOutlinedIcon />
        </ListItemIcon>
      </ListItemButton>
      <Divider />
      <BuyerInfoDialog
        close={close}
        isOpen={isOpen}
        companyId={order.contract.buyingCompanyId}
        openView={view}
      />
      {!compact && <Comments />}
    </List>
  );
}
